<template>
  <div class="general-view">
    <!-- <el-form :inline="true" class="form-inline">
      <el-form-item>
        <el-input v-model="keyword" placeholder="搜索(商户名)" @input="change" clearable>
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
      </el-form-item>
    </el-form> -->
    <el-table
      class="table"
      :data="list"
      stripe
      :sortable="true"
      :header-row-style="{color:'#333333'}"
      :sort-method="sortMethod">
      <el-table-column
        label="姓名"
        prop="name"
        width="180">
      </el-table-column>
      <el-table-column
        label="反馈内容"
        width="300"
        prop="text">
      </el-table-column>
      <el-table-column
        label="图片"
        width="300">
        <template slot-scope="scope">
          <div class="images">
            <div class="img" v-for="(item, index) in scope.row.images" :key="index">
              <img :src="item" v-img-frame v-img-auto/>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="时间">
        <template slot-scope="scope">
          <span>{{getDay(scope.row.updated_at)}}</span>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="pager"
      background
      :page-size="per_page"
      :page='page'
      layout="total, prev, pager, next, jumper"
      @current-change="currentChange"
      :total="total">
    </el-pagination>
  </div>
</template>
<script>
import request from '@/utils/request'
import getDay from '@/utils/getDay'
export default {
  name: 'generalView',
  data () {
    return {
      keyword: '',
      list: [],
      per_page: 12,
      page: 1,
      total: 0,
      show: false,
      sort: ''
    }
  },
  created () {
    this.getlist()
  },
  methods: {
    getlist () {
      let sendData = {
        per_page: this.per_page,
        page: this.page
        // key: this.keyword,
        // sort: this.sort
      }
      request({
        url: 'feedbacks',
        method: 'get',
        params: sendData
      }).then(res => {
        this.list = res.data.list
        this.total = res.data.item_total
      })
    },
    change () {
      this.page = 1
      this.getlist()
    },
    currentChange (e) {
      this.page = e
      this.getlist()
    },
    getDay (date) {
      return getDay(date)
    },
    sortMethod (a, b) {
      console.log(a, b)
    }
  }
}
</script>
<style lang="less" scoped>
.general-view {
  .form-inline {
    .select {
      width: 180px;
    }
  }
  .table {
    border: 1px solid #EBEEF5;
    border-bottom: none;
    .tenant {
      display: flex;
      align-items: center;
      .headimg {
        width: 30px;
        height: 30px;
        border-radius: 50%;
        overflow: hidden;
        background-color: #dddddd;
        margin-right: 5px;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
  .pager {
    margin-top: 15px;
    margin-bottom: 10px;
  }
  .images {
    display: flex;
    flex-wrap: wrap;
    .img {
      width: 80px;
      height: 80px;
      margin-right: 15px;
      margin-bottom: 15px;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        width: 100%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/index/feedback.vue